import { capitalize, MenuItem, Select } from '@mui/material';

import { durationOptions, type DurationFragment } from '@/utils/dateTime';

export const FragmentSelector = (props: {
  fragment: DurationFragment;
  onChange: (value: DurationFragment) => void;
}) => {
  const { fragment, onChange } = props;

  return (
    <Select
      data-testid='fragment-selector'
      className='w-[200px]'
      value={fragment}
      onChange={(e) => onChange(e.target.value as DurationFragment)}
    >
      {durationOptions
        .filter((option) => option !== 'hours')
        .map((option) => (
          <MenuItem key={option} value={option}>
            {capitalize(option)}
          </MenuItem>
        ))}
    </Select>
  );
};
